<template id="rfm">
  <section>
    <div class="row">
      <div class="col-sm-auto col-md-auto col-lg-auto mt-3 mb-5">
        <div class="card ml-5">
          <div class="card-header text-left">
            <i class=""></i>RFM Segmentation
          </div>
          <div class="card-body" id="menu" @contextmenu.prevent="$refs.menu.open">
            <vue-context ref="menu" class="bcg">
              <div class="click-event" v-on:mouseleave="closeMenu()">
                <a class="offset-lg-1" @click.prevent="">Print</a>
                <hr>
                  <a class="offset-lg-1" @click.prevent="">Send to Compaign</a>
                  <hr>
                <div class="hoverzone">
                  <a class="offset-lg-1">Other Action</a>
                  <hr>
<!--                  <ul class="menu">-->
                    <li>
                      <download-csv class="btn btn-default" :data="exportDataAll" :fields="fields" :name="momentAll">
                        Export All Data(.csv)
                      </download-csv>
                    </li>
                    <li>
                      <download-csv class="btn btn-default" :data="exportData" :fields="fields" :name="momentCell">
                        Export Cell Wise(.csv)
                      </download-csv>
                    </li>
<!--                    <li>
                      <a class="btn btn-default">Send to Compaign</a>
                    </li>-->
<!--                  </ul>-->
                </div>
              </div>
            </vue-context>

            <div class="table-responsive">
              <table class="table table-bordered agenda">
                <thead class="bg-dark text-white font-weight-lighter">
                <tr>
                  <th rowspan="2" style="width: 60px">
                            <span style="float: left">
                                R<i class="fa fa-arrow-down"></i>
                            </span>
                    <span style="float: right">
                                F<i class="fa fa-arrow-right"></i>
                            </span>
                  </th>
                  <th class="cell-width" v-for="(f,idx) in rfmsummary1" v-bind:key="idx">
                    F = {{ f.frequencyScore }} ({{ f.frequencyRange }})
                  </th>
                </tr>
                </thead>
                <thead>
                <tr>
                  <td>F <i class="fa fa-arrow-right"></i></td>
                  <td colspan="6">
                    <span v-for="(f,idx) in frequency" v-bind:key="idx" class="m-aln">
                        <div v-show="f.frequencyScore === 1">
                            <div
                                style="width:1px; height:70px; z-index:2011; background-color:gray;margin-bottom: 10px;margin-left: 35px">
                            </div>
                        </div>
                        <div v-show="f.frequencyScore === 1">
                            <div
                                style="width:1px; height:70px; z-index:2011; background-color:gray;margin-bottom: 10px;margin-left: 270px">
                            </div>
                        </div>
                        <div v-show="f.frequencyScore === 1">
                            <div
                                style="width:1px; height:70px; z-index:2011; background-color:gray;margin-bottom: 10px;margin-left: 507px">
                            </div>
                        </div>
                        <div v-show="f.frequencyScore === 1">
                            <div
                                style="width:1px; height:60px; z-index:2011; background-color:gray;margin-bottom: 10px;margin-left: 740px">
                            </div>
                        </div>
                        <div v-show="f.frequencyScore === 1">
                            <div
                                style="width:1px; height:60px; z-index:2011; background-color:gray;margin-bottom: 10px;margin-left: 975px">
                            </div>
                        </div>
                        <span style="margin-top: 10px;margin-left: 50px">
                            F = {{ f.frequencyScore }} ({{ f.frequencyRange }})
                        </span>
                    </span>
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(rowd,index) in output" v-bind:key="index">
                  <td>
                    R = {{ rowd["recencyScore"] }} <br> ({{ rowd["recencyRange"] }})
                  </td>
                  <td v-for="(col,idx) in Object.keys(scndArray[0])" v-bind:key="idx"
                      @mouseover="filterValue(col,rowd['recencyRange'])">
                    <span class="cell-align">{{ scndArray[index][col] }}</span>
                    <span class="tooltip-align"
                          v-b-tooltip.hover.topleft.html="'R'+': '+rowd['recencyScore']+'</br>'+
                            'F'+': ' + x1+'</br>'+'M'+ ': '+'#'+': '+'All'+'</br>'+'T'+': '+'#'+': '+scndArray[index][col]">......................<br>__________________________
                    </span>
                    <div>
                      <bar-chart x-key="monetaryScore" y-key="customerCount" :data="rowd.chData[col]">
                      </bar-chart>
                    </div>
                  </td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <td>M <i class="fa fa-arrow-right"></i></td>
                  <td colspan="6">
                    <span v-for="(m,idx) in monetary" v-bind:key="idx" class="m-aln">
                        <div v-show="m.monetaryScore === 1">
                            <div
                                style="width:1px; height:70px; z-index:2011; background-color:gray;margin-top: -80px;margin-left: 35px">
                            </div>
                        </div>
                        <div v-show="m.monetaryScore === 1">
                            <div
                                style="width:1px; height:70px; z-index:2011; background-color:gray;margin-top: -80px;margin-left: 270px">
                            </div>
                        </div>
                        <div v-show="m.monetaryScore === 1">
                            <div
                                style="width:1px; height:70px; z-index:2011; background-color:gray;margin-top: -70px;margin-left: 507px">
                            </div>
                        </div>
                        <div v-show="m.monetaryScore === 1">
                            <div
                                style="width:1px; height:60px; z-index:2011; background-color:gray;margin-top: -60px;margin-left: 740px">
                            </div>
                        </div>
                        <div v-show="m.monetaryScore === 1">
                            <div
                                style="width:1px; height:60px; z-index:2011; background-color:gray;margin-top: -60px;margin-left: 975px">
                            </div>
                        </div>
                        <span style="margin-top: 20px;margin-left: 50px">
                            M = {{ m.monetaryScore }} ({{ m.monetaryRange }})
                        </span>
                    </span>
                  </td>
                </tr>
                </tfoot>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
import BarChart from '../BarChart'
import {bus} from '@/bus'
import {VueContext} from 'vue-context'

export default {
  name: 'rfm',
  components: {BarChart, VueContext},
  props: {
    header: {
      type: String
    }
  },
  data: function () {
    return {
      momentAll: '',
      momentCell: '',
      //download data
      exportData: [],
      exportDataAll: [],
      fields: ['customerId', 'fromDate', 'toDate', 'rfmScope', 'rfmScopeQualifier', 'recencyTxnDate', 'rfmScore',
        'recencyScore', 'recencyValue', 'recencyRange', 'frequencyScore', 'frequencyValue', 'frequencyRange',
        'monetaryScore', 'monetaryValue', 'monetaryRange'],
      message: this.message,
      monetary: [],
      scndArray: [],
      output: [],
      rfmsummary1: [],
      frequency: [],
      frequencyRange: [],
      frequencyScore: [],
      recencyRange: [],
      monetaryRange: [],
      monetaryScore: [],
      x1: [], x2: [], x3: [], x4: [],
      exportValuesLoaded: false
    }
  },
  computed: {},
  created: function () {
    bus.$on('test', (data, data2) => {
      this.message = data,
          this.message2 = data2

    })
    this.loadValue()
    this.loadSummary1()
    this.loadSummary2()
    this.loadMonetary()
  },
  methods: {
    closeMenu: function () {
      this.$refs.menu.show = false
    },
    loadValue: function () {
      this.momentAll = `${moment().format('YYYY-MM-DD hh:mm')}_All_RFM_Data.csv`
      // Export All RFM data
      axios.get('/api/export-csv-all').then(res => {
        this.exportDataAll = res.data
      }, err => {
        console.log('Error in fetching Record', err)
      })
    },
    filterValue: function (e1, e2) {
      this.momentCell = `${moment().format('YYYY-MM-DD hh:mm')}_${e1}>${e2}_CellWise_RFM_Data.csv`

      // Export CellWise RFM data
      this.exportData = this.exportDataAll.filter(e => e.frequencyRange === e1 && e.recencyRange === e2)
      this.frequencyRange = Array.from(new Set(this.exportData.map(r => r.frequencyRange).filter(x => x != null)))
      this.recencyRange = Array.from(new Set(this.exportData.map(r => r.recencyRange).filter(x => x != null)))

      // console.log("this.exportData:", this.frequencyRange, this.recencyRange)
      this.x1 = Array.from(new Set(this.exportData.map(r => r.frequencyScore).filter(x => x != null)))
      this.x2 = Array.from(new Set(this.exportData.map(r => r.recencyScore).filter(x => x != null)))
      this.x3 = Array.from(new Set(this.exportData.map(r => r.monetaryScore).filter(x => x != null)))
      this.x4 = Array.from(new Set(this.exportData.map(r => r.monetaryRange).filter(x => x != null)))

    },
    loadSummary1: function () {
      axios.get('/api/rfm-analytics-rollup1/')
          .then(res => {
            this.rfmsummary1 = res.data
            this.frequencyRange = Array.from(new Set(this.rfmsummary1.map(r => r.frequencyRange).filter(x => x != null)))
            this.frequencyScore = Array.from(new Set(this.frequency.map(r => r.frequencyScore).filter(x => x != null)))
            console.log("this.rfmsummary1", this.rfmsummary1)
          }, err => {
            console.log('Error in fetching record', err)
          })
    },
    loadSummary2: function () {
      axios.get('api/rfm-analytics-pivoted/')
          .then(res => {
            this.output = res.data
            let intmt = this.output.map(function (el) {
              return el.rfRangeCustomerCount
            })
            intmt.forEach(key => {
                  const vals = JSON.parse(key)
                  this.scndArray.push(vals)
                }
            )
          }, err => {
            console.log('Error in fetching record', err)
          })
    },
    loadMonetary: function () {
      axios.get('/api/monetary-range/')
          .then(res => {
            this.monetary = res.data
            this.monetaryRange = Array.from(new Set(this.monetary.map(r => r.monetaryRange).filter(x => x != null)))
            this.monetaryScore = Array.from(new Set(this.monetary.map(r => r.monetaryScore).filter(x => x != null)))
          }, err => {
            console.log('Error in fetching record', err)
          })
    },
  }//Method Ends
}
</script>
<style scoped>
.table {
  font-size: 11px;
}

.table tr, .table td {
  height: 5px;
}

.table > tbody > tr > td, .table > tbody > tr > th, .table > tfoot > tr > td, .table > tfoot > tr > th, .table > thead > tr > td, .table > thead > tr > th {
  padding: 2px;
  /*border: 2px solid #ffffff;*/
}

.cell-width {
  width: 0px;
  text-align: center;

}

/*First Row First    Column*/
table.agenda tr:nth-child(1) td:first-child + td {
  background: #F9FCE8;
}

table.agenda tr:nth-child(2) td:first-child + td {
  background: #FDFED1;
}

table.agenda tr:nth-child(3) td:first-child + td {
  background: #F8F9B5;
}

table.agenda tr:nth-child(4) td:first-child + td {
  background: #F8F99F;
}

table.agenda tr:nth-child(5) td:first-child + td {
  background: #FBFC8C;
}

table.agenda tr:nth-child(6) td:first-child + td {
  background: #F9FA6F;
}

/*Second Row Second Column*/
table.agenda tr:nth-child(1) td:first-child + td + td {
  background: #F2FFCE;
}

table.agenda tr:nth-child(2) td:first-child + td + td {
  background: #F9FCE8;
}

table.agenda tr:nth-child(3) td:first-child + td + td {
  background: #FDFED1;
}

table.agenda tr:nth-child(4) td:first-child + td + td {
  background: #F8F9B5;
}

table.agenda tr:nth-child(5) td:first-child + td + td {
  background: #F8F99F;
}

table.agenda tr:nth-child(6) td:first-child + td + td {
  background: #FBFC8C;
}

/*Third Row Third Column*/
table.agenda tr:nth-child(1) td:first-child + td + td + td {
  background: #DFFFA4;
}

table.agenda tr:nth-child(2) td:first-child + td + td + td {
  background: #F2FFCE;
}

table.agenda tr:nth-child(3) td:first-child + td + td + td {
  background: #F9FCE8;
}

table.agenda tr:nth-child(4) td:first-child + td + td + td {
  background: #FDFED1;
}

table.agenda tr:nth-child(5) td:first-child + td + td + td {
  background: #F8F9B5;
}

table.agenda tr:nth-child(6) td:first-child + td + td + td {
  background: #F8F99F;
}

/*Fourth Row Fourth Column*/
table.agenda tr:nth-child(1) td:first-child + td + td + td + td {
  background: #BEFAA0;
}

table.agenda tr:nth-child(2) td:first-child + td + td + td + td {
  background: #DFFFA4;
}

table.agenda tr:nth-child(3) td:first-child + td + td + td + td {
  background: #F2FFCE;
}

table.agenda tr:nth-child(4) td:first-child + td + td + td + td {
  background: #F9FCE8;
}

table.agenda tr:nth-child(5) td:first-child + td + td + td + td {
  background: #FDFED1;
}

table.agenda tr:nth-child(6) td:first-child + td + td + td + td {
  background: #F8F9B5;
}

/*Fifth Row Fifth Column*/
table.agenda tr:nth-child(1) td:first-child + td + td + td + td + td {
  background: #85DE82;
}

table.agenda tr:nth-child(2) td:first-child + td + td + td + td + td {
  background: #BEFAA0;
}

table.agenda tr:nth-child(3) td:first-child + td + td + td + td + td {
  background: #DFFFA4;
}

table.agenda tr:nth-child(4) td:first-child + td + td + td + td + td {
  background: #F2FFCE;
}

table.agenda tr:nth-child(5) td:first-child + td + td + td + td + td {
  background: #F9FCE8;
}

table.agenda tr:nth-child(6) td:first-child + td + td + td + td + td {
  background: #FDFED1;
}

/*Sixth Row Sixth Column*/
table.agenda tr:nth-child(1) td:first-child + td + td + td + td + td + td {
  background: #36C234;
}

table.agenda tr:nth-child(2) td:first-child + td + td + td + td + td + td {
  background: #85DE82;;
}

table.agenda tr:nth-child(3) td:first-child + td + td + td + td + td + td {
  background: #BEFAA0;
}

table.agenda tr:nth-child(4) td:first-child + td + td + td + td + td + td {
  background: #DFFFA4;
}

table.agenda tr:nth-child(5) td:first-child + td + td + td + td + td + td {
  background: #F2FFCE;
}

table.agenda tr:nth-child(6) td:first-child + td + td + td + td + td + td {
  background: #F9FCE8;
}

/*Table Footer Color*/
table.agenda tfoot tr:nth-child(1) td:first-child + td {
  background: linear-gradient(to right, #E2FFFF 20%, #BAFFFF 40%, #9CFFFF 60%, #77F9F9 80%, #0AFBFB 100%);
}

hr {
  border: none;
  height: 1px;
  color: #333;
  background-color: darkgrey;
}

.bcg {
  text-align: left;
  opacity: 1;
  background-color: white;
  line-height: 2px;
}

.menu {
  position: relative;
  line-height: 10px;
  margin-top: 10px;
  display: none;
  height: auto;
  background-color: white;
  text-align: left;
}

.hoverzone {
  position: relative;
}

.hoverzone:hover .menu {
  display: block;
}

.cell-align {
  float: right;
  font-weight: bold;
}

.tooltip-align {
  color: transparent;
  cursor: pointer;
  width: auto;
  height: 100px;
  border-left: 100px solid transparent;
  background-color: transparent;
}

.m-aln {
  margin-left: 80px;
}
</style>